import React, { Component } from 'react';
import moment from 'moment';
import { 
  Table,
  DropdownButton, 
  MenuItem, 
  Glyphicon,
  Panel
} from 'react-bootstrap';

class SetTable extends Component {
  constructor(props) {
    super(props);
    this.renderRow = this.renderRow.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
  }

  handleDeleteClick(key) {
    this.props.deleteSet(key);
  }

  renderRow(key) {
    const set = this.props.sets[key];
    const exercise = this.props.exercises[set.exerciseKey];
    // the or set.exercise at the end of this is for old
    // sets that didn't have exerciseKeys. Eventually figure
    // out how to get rid of this.
    const exerciseName = (exercise && exercise.name) || set.exercise;

    const timeStamp = moment(new Date(set.timeStamp)).format('h:mm A');

    return (
      <tr key={key}>
        <td>{timeStamp.toString()}</td>
        <td>{exerciseName}</td>
        <td>{set.weight} lbs</td>
        <td>x</td>
        <td>{set.reps}</td>
        <td>
          <DropdownButton 
            title={<Glyphicon glyph="cog" />}
            bsSize="small"  
            id="Options"
            noCaret 
            pullRight
          >
            <MenuItem onClick={(event) => this.props.onEditClick(key)}>
              Edit
            </MenuItem>
            <MenuItem onClick={(event) => this.handleDeleteClick(key)}>
              Delete
            </MenuItem>
          </DropdownButton>
        </td>
      </tr>
    );
  }

  render() {
    const rows = Object.keys(this.props.sets)
                       .reverse()
                       .map(key => this.renderRow(key));

    return (
      <Panel>
        <Table fill striped condensed>
          <tbody>
            {rows}
          </tbody>
        </Table>
      </Panel>
    );
  }
}

SetTable.propTypes = {
  sets: React.PropTypes.object.isRequired,
  exercises: React.PropTypes.object.isRequired,
  onEditClick: React.PropTypes.func.isRequired,
  deleteSet: React.PropTypes.func.isRequired
}

export default SetTable;


// WEBPACK FOOTER //
// ./src/components/SetTable.jsx